import styled from "@emotion/styled";
import { Box } from "@mui/material";

export const AuthLayoutWrapper = styled(Box)`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  width: 100%;
  background-color: #e3ecfb;
  position: relative;
  overflow: hidden;
`;

export const AuthLayoutContent = styled(Box)`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  max-width: 1360px;
  height: auto;
  padding: 40px;
  position: relative;
  z-index: 2;
`;
